// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2mkr_","buttons":"SendReceipts_buttons__2VsM8","email":"SendReceipts_email__1P91X","bookApptTitle":"SendReceipts_bookApptTitle__PNv5J"};